module.exports = __webpack_public_path__ + "img/18.d9cadede.jpg";